<template>
    <CustomModal id="thank-you" noActions>
        <div class="position-relative">
            <div class="flex-center flex-column">
                <img src="/app/images/thank-you.svg" alt="thank-you">
                <p class="heading-short-medium py-16">Order Complete</p>
                <p class="text-tall-regular text-center" :class="{'pb-24': !isPickupEnabled}">Order <span class="text-tall-bold">#{{ orderNumber }}</span> is successfully paid{{ gPayPaymentMethodCopy }}.</p>
                <div v-if="isPickupEnabled" class="align-items-start bg-midnight-100 border-rounded-5 d-flex justify-content-between mt-24 px-32 py-24 w-100">
                    <p class="text-tall-medium d-flex text-midnight-800 align-items-center justify-content-around">
                        <Icon name="far fa-clock" size="1x" class="text-midnight-800 pr-8"/>
                        Pick-up time
                    </p>
                    <div>
                        <p class="text-tall-regular">{{ pickupDate }}</p>
                        <p class="text-tall-regular">{{ pickupTime }}</p>
                    </div>
                </div>
            </div>
        </div>
    </CustomModal>
</template>
<script lang="ts" setup>
import CustomModal from './CustomModal.vue';
import {Icon} from '@helcim/blizzard';
import {useDate} from '../../compositions';
import {computed} from 'vue';
import {PAYMENT_METHOD} from '../../scripts/constants';

const props = defineProps<{
    orderNumber: string,
    pickupTime: string,
    isPickupEnabled: boolean,
    paymentMethod: string,
}>();

const { time24HrTo12Hr, getTime24HrFromDateString } = useDate();

const pickupDate = computed(() => {
    if (props.pickupTime) {
        return new Date(props.pickupTime)
            .toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric'});
    }
    return '';
});

const pickupTime = computed(() => {
    if (props.pickupTime) {
        return time24HrTo12Hr(getTime24HrFromDateString(props.pickupTime));
    }
    return '';
});

const gPayPaymentMethodCopy = computed(() => {
    return props.paymentMethod === `${PAYMENT_METHOD.GOOGLE_PAY}` ? ' with Google Pay' : '';
});
</script>
